import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import LoadingGrid from 'organization/Marketplace/config/TemplateSelector/LoadingGrid'
import {UpdateTemplateFunction} from 'organization/Marketplace/config/types'
import UpsellPageEventTemplateCard from 'organization/Marketplace/config/TemplateSelector/UpsellPageEventTemplateCard'
import {useMarketplaceUpsellPageSampleEvents} from 'lib/event-api/event/use-marketplace-upsell-page-sample-events'

interface ObvioEventsGridProps {
  updateTemplate: UpdateTemplateFunction
}

export default function UpsellPageObvioEventsGrid(props: ObvioEventsGridProps) {
  const {updateTemplate} = props
  const {data: events} = useMarketplaceUpsellPageSampleEvents()

  if (!events) {
    return <LoadingGrid />
  }

  if (events.length < 1) {
    return <Typography>You don't have any events with a Upsell Page</Typography>
  }

  return (
    <>
      {events.map((event) => (
        <Grid item xs={12} md={4} key={event.id}>
          <UpsellPageEventTemplateCard
            event={event}
            updateTemplate={updateTemplate}
          />
        </Grid>
      ))}
    </>
  )
}
